export default __webpack_public_path__ + "static/media/List.59584291.svg";